/* @flow */

import React from 'react';

import UploadSteps from 'components/Upload/UploadSteps';
import style from 'components/Upload/style';

export default function Upload(props: any): React.Element {
  return (
    <div style={{ height: `100%` }}>
      <a data-testid="button-modal-cancel" style={{
        ...style.modalClose,
        transition: `color 0.3s ease`,
        color: props.allPending ? `red` : `rgb(66, 66, 66)`,
      }}
        onClick={ props.closeModal }>
         CANCEL &#10005;
      </a>

      <div style={ style.wizardHeader }>
        <a data-testid="button-modal-upload" style={{
          ...style.wizardNavItem,
          color: props.isActiveStep(0) ? `rgb(62, 62, 62)` : `red`,
          borderBottom: props.isActiveStep(0) ? `3px solid rgb(66, 133, 244)` : `none`,
          cursor: `pointer`,
        }} onClick={ () => props.setStep(0) }>
          <span>UPLOAD</span>
        </a>
        <a data-testid="button-modal-validate" style={{
          ...style.wizardNavItem,
          color: props.isActiveStep(1) ? `rgb(62, 62, 62)` : `rgb(177, 177, 177)`,
          borderBottom: props.isActiveStep(1) ? `3px solid rgb(66, 133, 244)` : `none`,
        }}>
          <span>VALIDATE</span>
        </a>
      </div>

      <div style={{ height: `calc(100% - 4.8rem)` }}>
        <UploadSteps {...props} />
      </div>
    </div>
  );
}
